import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export type MoreGroupsItemProps = {
  additionalGroups: number;
};

const moreGroupBoxStyles: SxProps<Theme> = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  width: '22px',
  height: '60px',
  position: 'absolute',
  boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
};

export const MoreGroupsItem = ({ additionalGroups }: MoreGroupsItemProps) => {
  const { t } = useTranslation();

  if (additionalGroups === 0) return null;

  return (
    <Stack
      direction="column"
      sx={{
        position: 'relative',
        height: '100%',
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: '600', fontSize: '11px', textTransform: 'uppercase' }}>
        {`+${additionalGroups} ${t('groups')}`}
      </Typography>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          height: '60px',
        }}
      >
        <Box
          sx={{
            ...moreGroupBoxStyles,
            backgroundColor: 'background.boxLight',
            height: '60px',
            left: 0,
          }}
        />
        <Box
          sx={{
            ...moreGroupBoxStyles,
            backgroundColor: 'background.boxDark',
            height: '58px',
            left: '19px',
          }}
        />
        <Box
          sx={{ ...moreGroupBoxStyles, backgroundColor: 'background.antiflashWhite', height: '55px', left: '38px' }}
        />
      </Stack>
    </Stack>
  );
};
